const reactHtmlAttributes = require('./react-html-attributes.json')

export default reactHtmlAttributes
module.exports = reactHtmlAttributes // for CommonJS compatibility



/** WEBPACK FOOTER **
 ** ./index.js
 **/